import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { removeToast } from '../../../redux/actions/GlobalToastActions';
import Toast from './Toast';

const GlobalToastContainer = ({ toasts, actions }) => {
  const onClose = (id) => {
    actions.removeToast(id);
  };

  return (
    <div className="global-toast-container">
      {toasts.map((toast) => (
        <Toast {...toast} key={toast.id} onClose={onClose} />
      ))}
    </div>
  );
};

GlobalToastContainer.propTypes = {
  toasts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = (state) => ({
  toasts: state.GlobalToastReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ removeToast }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalToastContainer);
